














import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import KendoDropdown from '@/components/kendo-dropdown/kendo-dropdown.vue';
import {NameValue, NameValues, OptionalNameValue} from '@/modules/neodash/model/types/interfaces/NameValue';
import {i18nMixin} from '@/modules/neodash/mixins/index';
import {IOptionalTextValue} from '@/interfaces/key-value-interface';

@Component({
  name: 'FilterDropDown',
  components: {
    KendoDropdown,
  }
})
export default class FilterDropDown extends Vue {
  public readonly translate = i18nMixin.methods.i18n;
  public isEnabled: boolean;
  public isRequired: boolean;
  public val: IOptionalTextValue<number>;

  @Prop({required: false})
  public value: OptionalNameValue;

  @Prop({required: false})
  public enable: boolean;

  @Prop({required: false})
  public required: boolean;

  @Prop({required: true})
  public label: string;

  @Prop({required: true})
  public dataSource: NameValues;

  @Watch('enable')
  public updateEnabled() {
    this.isEnabled = this.enable;
  }

  @Watch('required')
  public updateRequired() {
    this.isRequired = this.required;
  }

  @Watch('value')
  public updatePropValue() {
    this.updateValue();
  }

  @Watch('dataSource')
  public updateDataSource() {
    const {val} = this;
    if (!val)
      return;

    const shouldResetValue = !this.dataSource.some(x => !!x && x.value === val.value);
    if (!shouldResetValue)
      return;

    this.val = null;
    this.propagateValue();
  }

  public get formattedLabel() {
    const {translate, label} = this;

    if (!label)
      return '';

    return translate(label).toUpperFirstLetter();
  }

  public created() {
    this.isEnabled = this.enable != undefined ? this.enable : true;
    this.isRequired = this.required != undefined ? this.required : true;
    this.updateValue();
  }

  public get placeholder(): string {
    if (this.isRequired)
      return this.translate('Action.Select');

    return `${this.translate('Common.All')}...`;
  }

  public propagateValue(): void {
    const result: OptionalNameValue = !!this.val ? {
      name: this.val.text,
      value: this.val.value
    } : null;

    this.$emit('input', result);
    this.$emit('change', result);
  }

  private updateValue(): void {
    if (!this.value) {
      this.val = null;
      return;
    }

    const {name, value} = this.value;

    this.val = {
      value,
      text: name,
    };
  }
}
